import EventEmitter from 'eventemitter3';
import { AbstractWsConnector, wsDefaultConnector, WsMessageAllCasesType } from '@/ws';
import {
  AllCasesEventType,
  AllCasesGroupEventType,
  WsAllCasesEventMessageContent,
} from '@/ws/notifiers/cases-board/types';

export class CasesBoardNotifier {
  protected readonly eventEmitter = new EventEmitter();

  constructor(protected readonly wsConnector: AbstractWsConnector) {
    this.wsConnector.on((type, content) => {
      if (type !== WsMessageAllCasesType.CaseUpdated) return;

      this.handleCaseEventCreated(content as WsAllCasesEventMessageContent);
    });
  }

  protected handleCaseEventCreated(message: WsAllCasesEventMessageContent) {
    this.eventEmitter.emit(WsMessageAllCasesType.CaseUpdated, message);
  }

  on(eventType: AllCasesEventType, handler: (message: WsAllCasesEventMessageContent) => void) {
    this.wsConnector.invoke(AllCasesGroupEventType.JoinAllCasesGroup);
    this.eventEmitter.on(eventType, handler);
    return () => this.off(eventType, handler);
  }

  off(eventType: AllCasesEventType, handler?: (message: WsAllCasesEventMessageContent) => void) {
    this.wsConnector.invoke(AllCasesGroupEventType.LeaveAllCasesGroup);
    this.eventEmitter.off(eventType, handler, null, false);
  }
}

export const casesBoardNotifier = new CasesBoardNotifier(wsDefaultConnector);
